import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M21 3H3v18h18V3zm-6.8 8.2c-3.23 2.43-6.84-1.18-4.4-4.41 3.23-2.42 6.83 1.19 4.4 4.41z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M10 8.5h1v1h-1zm1.5 0h1v1h-1zm1.5 0h1v1h-1z"
}, "1")], 'MonitorWeightSharp');